import { MapSection } from "./MapSection";
import { MapRow } from "./MapRow";
import { Convertor } from "./Tiled JSON/Convertor";
import { IDictionary } from "../../../Utils/Collections/Dictionary";
import { Game, rnd } from "../../../Game";
import { ITiledMap } from "./Tiled JSON/Defs";
import { NodeList } from "../../../Utils/Collections/NodeList";
import { Pool } from "../../../Utils/Collections/Pool";
import { GameWorld } from "../GameWorld";
import { TileBase } from "../Ground Tiles/TileBase";



export class PathGenerator {
    /**
     * Celkovy pocet skupin se useky cesty
     */
    static readonly SECTION_GROUP_CNT = 6;

    /**
     * (RO) Staticky pristup
     */
    static get INSTANCE(): PathGenerator { return PathGenerator._INSTANCE; }
    private static _INSTANCE: PathGenerator;

    /**
     * Sekce rozdelene do skupin [index_skupiny][index_sekce]
     */
    private _secGroups: MapSection[][];

    /**
     * (RO) Celkovy pocet radek ve vsech sekcich
     */
    get rowCnt(): number { return this._rowCnt; }
    private _rowCnt: number;

    /**
     * Index aktualni skupiny sekci v seznamu skupin sekci (_secGroups)
     */
    private _curSecGroupId: number;

    /**
     * Zbyvajici sekce v aktualni skupine sekci
     */
    private _curSecGroup: NodeList<MapSection>;

    /**
     * Aktualni sekce
     */
    private _curSec: MapSection;

    /**
     * Index aktualni radky v ramci aktualni sekce
     */
    private _curSecRowId: number;

    /**
     * Index radky v ramci herniho sveta, na ktere zacina aktualni sekce
     */
    private _curSecWorldRowId: number;

    /**
     * Pool s volnymi PathEntry
     */
    private _freePathEntries: Pool<PathEntry>;

    /**
     * Zaznam vygenerovane cesty
     */
    private _recPath: PathEntry[];

    /**
     * Pozice v seznamu vygenerovanych sekci cesty
     */
    private _recPathPos: number;

    /**
     * Dosacne zapouzdreni readky
     */
    private _tmpMapRow: MapRowWrapper;

    /**
     * (RO) Pocet restartu stejne cesty
     */
    get samePathRestartCnt(): number { return this._samePathRestartCnt; }
    private _samePathRestartCnt: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        PathGenerator._INSTANCE = this;

        this._tmpMapRow = new MapRowWrapper();
        this._samePathRestartCnt = 0;
        this._freePathEntries = new Pool<PathEntry>(PathEntry, 20, true);
        this._recPath = [];

        // Prevod JSONu s Tiled daty na mapove sekce
        let convertor = new Convertor();

        this._secGroups = [];
        this._curSecGroup = new NodeList<MapSection>();
        this._rowCnt = 0;

        for (let i = 0; i < PathGenerator.SECTION_GROUP_CNT; i++) {
            let sections: MapSection[] = [];

            convertor.convert(Game.app.assets.find(Game.MAP_ASSET_KEY + i, pc.eAssetType.json).resource as ITiledMap, sections);
            this._secGroups.push(sections);

            sections.forEach((s: MapSection) => { this._rowCnt += s.rows.length; });
        }

        convertor.release();

        console.log("map size: " + this._rowCnt);
    }

    //-------------------------------------------------------------------------
    /**
     * Reset
     * @param pathEntryId Index zaznamu, od ktereho se ma generator cesty resetovat. Pokud < 0, tak dojde k vymazani doposud vygenerovanych zaznamu.
     */
    //-------------------------------------------------------------------------
    reset(pathEntryId: number = -1): void {
        if (pathEntryId > 0) {
            // Obnovit seznam zbyvajicich sekci podle indexu zaznamu cesty
            while (this._recPathPos - 1 > pathEntryId) {
                if (this._secGroups[this._curSecGroupId].length == this._curSecGroup.size) {
                    // Presun do predchozi skupiny sekci
                    this._curSecGroupId--;
                    this._curSecGroup.clear();
                }

                // Vratit sekci do seznamu zbyvajicich sekci aktualni skupiny
                let pathEntry = this._recPath[--this._recPathPos];

                this._curSecGroup.add(pathEntry.sectionData, pathEntry.sectionId);
            }

            let pathEntry = this._recPath[pathEntryId];

            this._curSec = pathEntry.sectionData;
            this._curSecRowId = this._curSec.rows.length - 1;
            this._curSecWorldRowId = pathEntry.sectionRowPos;
        }
        else {
            this._recPathPos = 0;
            this._curSec = undefined;
            this._curSecWorldRowId = 0;

            if (pathEntryId < 0) {
                this._recPath.forEach((entry: PathEntry) => { this._freePathEntries.returnItem(entry); });
                this._recPath.length = 0;

                this._samePathRestartCnt = 0;
            }
            else {
                this._samePathRestartCnt++;
            }

            this.prepareSecGroup(0);
            this.prepareSection();
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci index pristi radky v ramci herniho sveta
     */
    //-------------------------------------------------------------------------
    getNextRowWorldId(): number {
        return this._curSecWorldRowId + this._curSec.rows.length - (this._curSecRowId + 1);
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci dalsi radek cesty. Vracena hodnota je pouze docasna a pri dalsim volani bude premazana!!!
     */
    //-------------------------------------------------------------------------
    getNextRow(): MapRowWrapper {
        this._tmpMapRow.init(this._recPathPos, this._curSec.rows[this._curSecRowId]);

        // Prechod na dalsi radku
        if (this._curSecRowId > 0) {
            this._curSecRowId--;
        }
        else {
            if (this._curSecGroup.empty)
                // Prechod do dalsi skupiny sekci
                this.prepareSecGroup((this._curSecGroupId + 1 < this._secGroups.length ? this._curSecGroupId + 1 : this._curSecGroupId - 2));

            this.prepareSection();
        }

        return this._tmpMapRow;
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci radek z vygenerovane cesty.
     * @param pathEntryId Index zaznamu ve vygenerovane ceste
     * @param rowId Index radky v ramci sekce
     */
    //-------------------------------------------------------------------------
    getRow(pathEntryId: number, rowId: number): MapRowWrapper {
        return this._tmpMapRow.init(pathEntryId, this._recPath[pathEntryId].sectionData.rows[rowId]);
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci zaznam z vygenerovane cesty
     * @param entryId Index zaznamu
     */
    //-------------------------------------------------------------------------
    getPathEntry(entryId: number): PathEntry {
        return (entryId < this._recPath.length ? this._recPath[entryId] : undefined);
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci index zaznamu trasy podle indexu radky
     * @param rowId Index radky v ramci cele vygenerovane trasy
     * @returns Index zaznamu, ktery obsahuje danou radku nebo -1, pokud zaznam neexistuje
     */
    //-------------------------------------------------------------------------
    getPathEntryId(rowId: number): number {
        let entryId = this._recPath.length - 1;

        if (entryId < 0 || this._recPath[entryId].sectionRowPos + this._recPath[entryId].sectionData.rows.length - 1 < rowId)
            return -1;

        while (entryId >= 0) {
            if (rowId >= this._recPath[entryId].sectionRowPos)
                return entryId;

            entryId--;
        }

        return -1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private prepareSecGroup(groupId: number): void {
        this._curSecGroup.clear();
        this._curSecGroupId = groupId;

        this._secGroups[groupId].forEach((section: MapSection) => {
            this._curSecGroup.add(section);
        });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private prepareSection(): void {
        let secId: number;

        if (this._curSec)
            this._curSecWorldRowId += this._curSec.rows.length;

        if (this._recPathPos < this._recPath.length) {
            secId = this._recPath[this._recPathPos].sectionId;
        }
        else {
            // Vybrat sekci nahodne
            secId = rnd.randomIntIn(0, this._curSecGroup.size - 1);
        }

        this._curSec = this._curSecGroup.removeById(secId);
        this._curSecRowId = this._curSec.rows.length - 1;

        if (this._recPathPos == this._recPath.length)
            // Ulozit vyber
            this._recPath.push(this._freePathEntries.getItem().set(secId, this._curSecWorldRowId, this._curSec));

        this._recPathPos++;
    }
}



export class MapRowWrapper {
    /**
     * (RO) Index zaznamu ve vygenerovane ceste, do ktereho radka patri
     */
    get pathEntryId(): number { return this._pathEntryId; }
    private _pathEntryId: number;

    /**
     * (RO) Data radky
     */
    get row(): MapRow { return this._row; }
    private _row: MapRow;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(pathEntryId: number, row: MapRow): MapRowWrapper {
        this._pathEntryId = pathEntryId;
        this._row = row;

        return this;
    }
}



export class PathEntry {
    /**
     * (RO) Index sekce v seznamu zbyvajicich sekci pro aktualni skupinu
     */
    get sectionId(): number { return this._sectionId; }
    private _sectionId: number;

    /**
     * (RO) Pozice sekce v hernim svete v radcich (prvni radek prvni sekce ma index 0)
     */
    get sectionRowPos(): number { return this._sectionRowPos; }
    private _sectionRowPos: number;

    /**
     * Pozice sekce v hernim svete v jednotkach
     */
    get sectionPos(): number { return GameWorld.Z - this._sectionRowPos * TileBase.SIZE; }

    /**
     * (RO) Data sekce
     */
    get sectionData(): MapSection { return this._sectionData; }
    private _sectionData: MapSection;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        this._sectionId = -1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    set(sectionId: number, sectionRowPos: number, sectionData: MapSection): PathEntry {
        this._sectionId = sectionId;
        this._sectionRowPos = sectionRowPos;
        this._sectionData = sectionData;

        return this;
    }
}